module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/favicon.ico
// module id = U0cd
// module chunks = 0